import type { RouteLocationAsPathGeneric } from "vue-router"
import { joinURL } from "ufo"

export function useTTSSourceUrl() {
  const origin = useCurrentOrigin()
  const route = useRoute()

  return function createSourceUrl(href: RouteLocationAsPathGeneric | undefined | null) {
    if (!href) {
      return joinURL(origin, route.path)
    }

    const url = new URL(href.path, origin)
    if (href.query) {
      for (const queryKey in href.query) {
        const value = href.query[queryKey]
        if (value) {
          url.searchParams.set(queryKey, String(value))
        }
      }
    }

    return url.href
  }
}
